import React, {memo, useCallback, useEffect, useState} from 'react';
import axios from "axios";
import * as constants from "@constants/index";
import {LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import {
    DELETE_NOTE_REQUEST,
    GET_CUSTOMER_DEBT_REQUEST,
    GET_SYSTEM_NOTES_REQUEST,
    SEND_SYSTEM_NOTE_REQUEST
} from "@redux/Customer/actions";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import usePrevious from "@hooks/useprevious";
import notify from "@utils/notify";
import NotesComponent from "@pages/components/DebtManagement/CustomerOverview/NotesComponent.tsx";

const NotesListComponent = ({ type,customerId,userId }) => {
    const {
        getSystemNotesSuccess,
        getSystemNotesError,
    } = useSelector((state) => state.customer, shallowEqual);

    const getSystemNotesSuccessPrev = usePrevious(getSystemNotesSuccess);
    const getSystemNotesErrorPrev = usePrevious(getSystemNotesError);
    const [loading,setLoading] = useState(true);
    const [error,setError] = useState({
        message: {
            show: false,
            message: ''
        }
    });
    const dispatch = useDispatch();
    const noteTabs = [
        {
            key: 'all',
            label: 'All',
        },
        {
            key: 'Customer',
            label: 'Customer',
        },
        {
            key: 'Payment',
            label: 'Payment',
        },
        {
            key: 'Deal',
            label: 'Deal',
        },
        {
            key: 'DebtRecovery',
            label: 'Debt Recovery',
        },
        {
            key: 'Logistics',
            label: 'Logistics',
        },

    ]

    const fetchNotes = async () => {
        if (!type || !customerId) return;
        setLoading(true)
        dispatch({
            type: GET_SYSTEM_NOTES_REQUEST,
            payload: {
                id: customerId,
                type,
            }
        });
    };

    useEffect(()=>{
        if (getSystemNotesError && getSystemNotesErrorPrev === false) {
            setLoading(false)
            notify.warning('Something went wrong please try again later!');
        }
    },[getSystemNotesError,getSystemNotesErrorPrev])
    useEffect(()=>{
        if (getSystemNotesSuccess && getSystemNotesSuccessPrev === false) {
            setLoading(false)
        }
    },[getSystemNotesSuccess,getSystemNotesSuccessPrev])

    useEffect(() => {
        fetchNotes();
    }, [type, customerId]);

    if (loading) return <div>Loading notes...</div>;

    return (
        <NotesComponent
            profileDataId={userId}
            customerId={customerId}
            error={error}
            setError={setError}
            noteTabs={noteTabs}
        />
    );
};



export default NotesListComponent;
